import { ContentWithAside } from "layouts/kiosk-h"
import { EMKidsAndFamilyKioskHPage } from "./pages/em-kids-and-family/index.kiosk"
import { themeOptionFactories } from "./theme"
import { EMKidsAndFamilyMobilePage } from "./pages/em-kids-and-family"

export const emKidsAndFamily = {
  themeOptionFactories,
  ignoreAppThemeFactory: false,
  routes: {
    mobile: [
      {
        path: "kids-and-family",
        element: <EMKidsAndFamilyMobilePage />,
      },
    ],
    "kiosk-v": [],
    "kiosk-h": [
      {
        path: "kids-and-family",
        element: <EMKidsAndFamilyKioskHPage Layout={ContentWithAside} />,
      },
    ],
  },
}
